import type { IComponentController } from "angular";

export class StepIconComponentController implements IComponentController {
    public static $inject: string[] = [];
}
